var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomPage',{attrs:{"title":"我的团队"}},[_c('div',{staticClass:"content",attrs:{"slot":"content"},slot:"content"},[_c('Navbar',{ref:"Navbar",on:{"getData":_vm.getData}}),_c('List',{attrs:{"data":_vm.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }